import {
    faBook,
    faExclamationTriangle,
  } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from './authentication/AuthContext';
import Select from "react-select"; // Add this import for the dropdown menu
import SessionHistoryPanel from "./history/SessionHistoryPanel";

function Profile() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [profileData, setProfileData] = useState({});
    const { token, setToken } = useAuth(); // Use AuthContext for setting token
    const [gameConfigs, setGameConfigs] = useState([]);
    const [selectedGameConfig, setSelectedGameConfig] = useState(null);

    const fetchProfileInfos = async () => {
        try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/profile`, {
            method: "GET",
            headers: {
            Authorization: "Bearer " + token,
            },
        });

        if (!response.ok) {
            if (response.status === 401 || response.status === 422) {
            navigate("/login"); // Use navigate to redirect to "/login"
            } else {
            // Handle other error responses
            console.error("Error fetching profile data:", response.statusText);
            }
            return;
        }

        return await response.json();
        } catch (error) {
        console.error("Error fetching profile data:", error);
        }
    };

    const fetchGameConfigs = async (allowedConfigIds) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/get_all_game_configs`, {
                method: "GET",
                headers: {
                    Authorization: "Bearer " + token,
                },
            });
    
            if (response.ok) {
                const configs = await response.json();
                setGameConfigs(
                    configs
                        .filter(config => allowedConfigIds.includes(config._id))
                        .map(config => ({ value: config._id, label: config.name }))
                );
            } else {
                console.error("Error fetching game configurations:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching game configurations:", error);
        }
    };
    

    useEffect(() => {
        setLoading(true);
        const initProfile = async () => {
            const res = await fetchProfileInfos();
            if (res && res.msg === "Token has expired") {
                navigate("/login");
                return;
            }
    
            if (res) {
                res.access_token && setToken(res.access_token);
    
                const newProfileData = {
                    firstname: res.firstname,
                    certification: res.certification_level,
                    is_admin: res.is_admin,
                    is_anim_serious_game: res.is_anim_serious_game,
                    list_configs_id_serious_game: res.list_configs_id_serious_game,
                };
    
                setProfileData(newProfileData);
                await fetchGameConfigs(newProfileData.list_configs_id_serious_game);
    
                setLoading(false);
            }
        };
    
        initProfile();
    }, []);
    

    const handleLaunchAtelier = () => {
        if (!selectedGameConfig) {
            alert("Veuillez sélectionner une configuration de jeu.");
            return;
        }
        navigate(`/game_config/${selectedGameConfig.value}`);
    };

    return (
        <Fragment>
            {loading ? (
            <div className="loader-container">
                <img src="/img/loading.gif" className="loader" />
            </div>
            ) : !profileData.is_anim_serious_game ? (
                <div className="profile-page">
                  <div className="error-container">
                    <FontAwesomeIcon icon={faExclamationTriangle} size="4x" color="#FF9900" />
                    <h2 className="color-blue" style={{ marginTop: "1rem" }}>
                    {profileData.firstname}, vous n'avez pas les droits pour accéder à cette page.
                    </h2>
                    <p>Contactez un administrateur pour qu'il vous octroie les droits à la nouvelle plateforme.</p>
                  </div>
                </div>
            ) : (
            <div className="profile-page">
                <div className="profile-top-container">
                    <h1 className="color-blue">Bonjour {profileData.firstname} !</h1>
                    <a
                    href="https://compte-gouttes.notion.site/Espace-animateurs-e39d0790584c436f96fe86ad8bfef3d8?v=7425610aa5fb4f9ead7828f78dd850b9"
                    target="_blank"
                    rel="noreferrer"
                    >
                    <button className="orange-button-admin new-workshop-button">
                        <FontAwesomeIcon icon={faBook} style={{ marginRight: 7 }} />
                        Ressources animateur
                    </button>
                    </a>
                </div>
                <div className="workshops-list-container">
                {profileData.is_admin ? 
                    (<div className="profile-config-container">
                    <div className="profile-top-container">
                        <h2 className="profile-workshop-title color-blue">
                        Gérer les configurations
                        </h2>
                    </div>
                    <div className="stats-wrapper">
                        <button className="blue-button-admin" onClick={() => navigate('/builder')}>
                            Constructeur d'ateliers
                        </button>
                    </div>
                    </div>):(<div></div>)}

                    <div className="launch-atelier-container">
                        <h2 className="color-blue">Lancer un nouvel atelier</h2>
                        <div className="launch-atelier-row">
                            <Select
                                options={gameConfigs}
                                onChange={setSelectedGameConfig}
                                placeholder="Sélectionnez une configuration"
                                className="game-config-dropdown"
                            />
                            <button
                                className="orange-button-admin game-config-launch-button"
                                onClick={handleLaunchAtelier}
                            >
                                Lancer
                            </button>
                        </div>
                    </div>

                    {/* MES SÉANCES — à l'emplacement que le code réservait en
                        commentaire depuis l'ancienne plateforme (« Ateliers
                        animés », « Personnes formées ») : les données
                        existent maintenant, cf. api/session_history.py. */}
                    <SessionHistoryPanel
                        token={token}
                        setToken={setToken}
                        isAdmin={Boolean(profileData.is_admin)}
                    />

                    {profileData.is_admin && (
                        <div className="manage-animators-section">
                            <h2 className="color-blue">Gérer les animateurs</h2>
                            <div className="manage-animators-buttons">
                                <button className="blue-button-admin">Liste des animateurs</button>
                                <button
                                    className="blue-button-admin"
                                    onClick={() => navigate('/animator_form')} // Wrap navigate in an arrow function
                                >
                                    Ajouter un animateur
                                </button>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        )}
        </Fragment>
    )
}

export default Profile;